import { get } from 'lodash';
import { ApplicantEntity } from '@lendi/core-constants';

import { FIELD_PATHS, FIELD_VALUES } from '@funnels/constants';
import { AnyFormValues, RelatedParty, StoreApplicant } from '@funnels/types';
import { getGuarantorType, GuarantorType } from '@funnels/utils';

/**
 * Exclude Security Guarantors, Company or Trust
 * @returns true if applicant is eligble for credit report
 */
export const isEligibleForCreditReport = (applicant: StoreApplicant, relatedParties: RelatedParty[]) => {
  return (
    applicant.entity === ApplicantEntity.Person &&
    (applicant.applicantType === FIELD_VALUES.BORROWER ||
      getGuarantorType(applicant, relatedParties) === GuarantorType.ServicingGuarantor)
  );
};

export const getCreditReportEligibleApplicants = (formValues: AnyFormValues): StoreApplicant[] =>
  get(formValues, FIELD_PATHS.APPLICANTS(), [] as StoreApplicant[]).filter((applicant: StoreApplicant) =>
    isEligibleForCreditReport(applicant, get(formValues, FIELD_PATHS.RELATED_PARTIES(), [] as RelatedParty[]))
  );
